import { ElementRef, Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Actions } from 'src/app/components/shared/types/actions.type';
import { ToastActions } from 'src/app/components/shared/sharedComponents/mu-toast/mu-toast-componet-enum';
import { ObservableManager } from '../../types/observableManager.type';
import { PermissionService } from '../../sharedModules/permission/permission.service';
import { UtilsService } from '../../sharedServices/utils.service';
import { CountryShared } from '../../models/interface/country.interface';

@Injectable({
  providedIn: 'root',
})
export class MuLayoutService implements OnDestroy {
  countryValue = new BehaviorSubject('');
  currentCountryValue = this.countryValue.asObservable();
  menuSource$: Observable<string>;
  resetSource$: Observable<unknown>;
  customLayoutContentClassSubject: Subject<string> = new Subject<string>();
  customLayoutContentClass$: Observable<string> = this.customLayoutContentClassSubject.asObservable();
  private obserVableManager = new ObservableManager();

  /**
   *  Prime menu services
   */
  private menuSource = new Subject<string>();
  private resetSource: any = new Subject();
  private layoutMainSubject = new Subject<ElementRef>();
  private layoutMain$ = this.layoutMainSubject.asObservable();
  toastActions: Actions<ToastActions, any>;

  constructor(private permissionService: PermissionService, private utilsService: UtilsService) {
    this.menuSource$ = this.menuSource.asObservable();
    this.resetSource$ = this.resetSource.asObservable();
  }

  ngOnDestroy() {
    this.obserVableManager.release();
  }

  /**
   * convert observable to Promise
   * @returns {Promise<string>} response
   */
  getCountryAsPromise(): Promise<string> {
    return new Promise(resolve => {
      this.obserVableManager.watch(this.countryValue).subscribe(value => {
        resolve(value);
      });
    });
  }

  /**
   * get current country
   * @returns {CountryShared} response
   */
  async getCountry(): Promise<CountryShared> {
    const value = await this.getCountryAsPromise();
    return environment.countries.find(country => country.geoName === value);
  }

  /**
   * checl offline flag
   * @returns
   */
  async checkOfflineFlag(): Promise<boolean> {
    return environment.guardClause;
  }

  /**
   *  Country services to notificate next event
   */

  public changeCountryValue(countryVal: string) {
    localStorage.setItem('location', countryVal);
    this.countryValue.next(countryVal);
  }

  /**
   *  Menu services to notificate next event
   */

  public onMenuStateChange(key: string) {
    this.menuSource.next(key);
  }

  /**
   *  Reset next event
   */

  public reset() {
    this.resetSource.next();
  }

  /**
   * set layout main
   *
   * @param {ElementRef} layoutMain
   */
  setLayoutMain(layoutMain: ElementRef): void {
    this.layoutMainSubject.next(layoutMain);
  }

  /**
   * get observable of layout main html element
   *
   * @return {Observable<ElementRef>} response
   */
  get layoutMain(): Observable<ElementRef> {
    return this.layoutMain$;
  }

  /**
   * set layout content custom class
   * @param {string} customClass
   */
  setCustomLayoutContentClass(customClass: string): void {
    this.customLayoutContentClassSubject.next(customClass);
  }

  /**
   * get layout content custom class
   */
  get customLayoutContentClass(): Observable<string> {
    return this.customLayoutContentClass$;
  }

  /**
   * set Actions for toast
   * @param {Actions} actions
   */
  setToastAction(actions: Actions<ToastActions, any>): void {
    this.toastActions = actions;
  }

  /**
   * get Actions for toast
   */
  getToasActions(): Actions<ToastActions, any> {
    return this.toastActions;
  }

  /**
   * get country in storage
   * @returns {CountryShared} response
   */
  getCountryInStorage(): CountryShared {
    return environment.countries.find(x => x.geoName === localStorage.getItem('location') || environment.countries[0].geoName);
  }
}
